<template>
  <!-- 注册审核 -->
  <div class="role">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['系统配置', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >添加</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">类型：</label>
        <el-select
          v-model="searchForm.type"
          placeholder="类型"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="商城后台" value="B2B"></el-option>
          <el-option label="业务通" value="YWT"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChange"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        show-overflow-tooltip
        label="名称"
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="entName"
        align="center"
        show-overflow-tooltip
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        prop="des"
        align="center"
        show-overflow-tooltip
        label="描述"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <!-- <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";

export default {
  name: "role",
  mixins: [formatStatus],
  data() {
    return {
      /**表格数据 */
      // {
      //   id:"",
      //   entId:"",
      //   name:"",
      //   des:"",
      //   sort:"",
      //   funId:"",
      //   organ:"",
      //   organId:"",
      //   status:""
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        name: "",
        isUsing: "99",
        type: "99",
      },
      /**select选中项 */
      selectedList: [],
    };
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  filters: {
    /**使用混入 转换tips状态 */
    /**使用混入 转换状态码 */
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      this.$request({
        url: "Role/RoleList",
        method: "post",
        data: {
          entId: window.localStorage.getItem("entId"),
          Source: this.searchForm.type,
          status: this.searchForm.isUsing,
          strWhere: this.searchForm.name,
          pageIndex: this.currPage,
          pageSize: this.pageSize,
        },
      })
        .then((res) => {
          this.allPage = res.Total;
          this.tableData = [];
          if (res.Code) {
            for (let i = 0; i < res.Obj.length; i++) {
              this.tableData.push({
                id: res.Obj[i].Id,
                name: res.Obj[i].RoleName,
                type: res.Obj[i].Source,
                des: res.Obj[i].Describe,
                sort: res.Obj[i].Sort,
                funId: res.Obj[i].MethodId,
                entId: res.Obj[i].EntId,
                entName: res.Obj[i].entname,
                status: res.Obj[i].Status,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },

    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**新增角色 */
    handleAdd(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify(row));
      } else {
        prams = row;
      }
      this.$router.push({
        path: "addRole",
        query: {
          row: prams,
        },
      });
      prams = null;
    },
    /**修改角色状态 */
    changeStatus(row) {
      let data = {
        type: "delRole",
      };
      let id = row.id;
      this.$requestSys({
        url:
          "main/ashx/ReturnJson.ashx?type=delRole&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=1&status=1&strWhere=" +
          id,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getTableData();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**删除角色 */
    handleDel() {
      if (this.selectedList.length == 1) {
        this.$confirm("确定删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        })
          .then(() => {
            let row = this.selectedList[0];
            this.changeStatus(row, 0);
          })
          .catch(() => {});
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped>
.role {
  width: 100%;
  height: 100%;
}
</style>
